import { AbstractFormatObjectAlert } from "./AbstractFormatObjectAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";

export abstract class AbstractEmptyAlert extends AbstractFormatObjectAlert {
  constructor(object: IFormatObjectEditable) {
    super(object, true);
  }

  get description(): string {
    return "入力されていないため、登録できません。";
  }
}
